/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { StorageModule } from "@vlinder-web/storage-module-react";
import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICurrencyExchangeRateMethods extends IPluginMethodMap {
  getCurrencyExchangeRate(): Promise<any>;
}

export class CurrencyExchangeRateService implements IAgentPlugin {
  readonly methods: ICurrencyExchangeRateMethods;

  constructor() {
    this.methods = {
      getCurrencyExchangeRate: this.getCurrencyExchangeRate.bind(this),
    };
  }
  async getCurrencyExchangeRate() {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageSrv = StorageModule.getInstance();

    try {
      if (client) {
        const res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });

        if (res?.data?.getCurrencyExchangeRate) {
          storageSrv.set(
            "currencyExchangeLocal",
            res?.data?.getCurrencyExchangeRate,
            "local"
          );
          storageSrv.set(
            "currencyExchangeSession",
            res?.data?.getCurrencyExchangeRate,
            "session"
          );

          return res?.data?.getCurrencyExchangeRate;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
